import { Anchor, Icon } from "@sellar-io/components";
import { ReactNode } from "react";
import { TooltipContainer } from "@sellar-io/components";

export const DefaultPriceListTooltip = ({
  hasMultipleDefaults,
  children,
}: {
  hasMultipleDefaults: boolean;
  children: ReactNode;
}) => {
  return (
    <TooltipContainer
      enable={true}
      color="white"
      text={
        <div className="flex max-w-[300px] items-center gap-2 px-1 py-2">
          <Icon
            icon="INFORMATION_OUTLINE"
            className="flex-none text-zinc-800"
          />
          <div>
            {hasMultipleDefaults && (
              <div className="text-base font-semibold text-zinc-800">
                You need to choose one default price list
              </div>
            )}
            <div className="text-sm text-zinc-700">
              {hasMultipleDefaults ? (
                <p>
                  To show new customers the correct pricing on the Market, you
                  need to choose one default price list
                  <br />
                  <br />
                  <Anchor
                    className="inline-flex items-center gap-1 text-sm font-semibold text-blue-600 uppercase underline"
                    href="/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn more
                    <Icon icon="ARROW_TOP_RIGHT" size={0.6} />
                  </Anchor>
                </p>
              ) : (
                <p>
                  Your default price list is the pricing that new customers see
                  on the Market
                </p>
              )}
            </div>
          </div>
        </div>
      }
    >
      {children}
    </TooltipContainer>
  );
};
